import { useTranslation } from 'react-i18next';

import { MAGIC_SEARCH_KEY_CLASS } from '../constants';
import { MagicSearchCloseButtonProps } from '../magic-search-palette.type';

export const MagicSearchCloseButton = ({ onClose }: MagicSearchCloseButtonProps) => {
  const { t } = useTranslation();

  return (
    <button
      type='button'
      onClick={onClose}
      aria-label='Close'
      className='shrink-0 rounded-md px-1 py-1 text-body-s text-secondary hover:text-primary focus-visible:outline-2 focus-visible:outline-offset-2'
      data-testid='magic-search--close'>
      <span className='sm:hidden'>{t('common:cancel')}</span>
      <span className='hidden sm:inline'>
        <kbd className={MAGIC_SEARCH_KEY_CLASS}>esc</kbd>
      </span>
    </button>
  );
};
